"use client";

import { BSRSubtract } from "./bsr/BSRSubtract";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Subtract as LegacySubtract } from "./legacy/Subtract";

export const Subtract = createBSRExperimentIcon(LegacySubtract, BSRSubtract);
